export default function getLandingMessage(store, messageDef) {
  const intlState = store.getState().intl || {};
  const locale = intlState.locale || 'en-US';
  const localeMessages = intlState.messages && intlState.messages[locale];

  return (localeMessages && localeMessages[messageDef.id]) || messageDef.defaultMessage;
}
